export const PROGRAM_NAMES = {
  CCM: 'CCM',
  CoCM: 'CoCM',
  RPM: 'RPM',
  RTM: 'RTM',
  BHI: 'BHI',
  APCM: 'APCM',
  PIN: 'PIN',
  CHI: 'CHI',
  TCM: 'TCM',
  PCM: 'PCM',
  Telemedicine: 'Telemedicine'
} as const

export const PROGRAM_SECTION_IDS = {
  CCM: 'ccm',
  RPM: 'rpm',
  RTM: 'rtm',
  APCM: 'apcm',
  BEHAVIORAL_HEALTH: 'behavioral-health',
  PCM: 'pcm',
  TCM: 'tcm',
  PIN: 'pin',
  CHI: 'chi',
  TELEHEALTH: 'telehealth'
} as const

export const PROGRAM_RADIO_GROUP_IDS = {
  CCM: 'ccm',
  RPM_MONITOR: 'rpm-monitor',
  RPM_MEASURE: 'rpm-measure',
  RTM: 'rtm',
  APCM: 'apcm',
  BHI: 'bhi',
  COCM: 'cocm',
  PCM_CLINICAL_STAFF: 'pcm-clinical-staff',
  PCM_PHYSICIAN: 'pcm-physician',
  TCM: 'tcm',
  PIN_GENERAL: 'pin-general',
  PIN_PEER: 'pin-peer',
  CHI: 'chi'
} as const

export const PROGRAMS = {
  CCM: 1,
  PCM: 11,
  CoCM: 7,
  RPM: 2,
  RTM: 4,
  BHI: 5,
  APCM: 6,
  PIN: 8,
  CHI: 9,
  TCM: 10,
  PCM: 11,
  Telemedicine: 3
} as const

export const PROGRAM_TYPE_TO_NAME: Record<number, string> = Object.fromEntries(
  (Object.keys(PROGRAMS) as (keyof typeof PROGRAMS)[]).map((programKey) => [
    PROGRAMS[programKey],
    PROGRAM_NAMES[programKey]
  ])
)

// ProgramType is the program name used as filter/display keys.
// Numeric backend program type values are stored in PROGRAMS.
export type ProgramType = (typeof PROGRAM_NAMES)[keyof typeof PROGRAM_NAMES]

export const PROGRAM_NAME_LIST = Object.values(PROGRAM_NAMES) as ProgramType[]
